import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, concatMap, tap} from "rxjs/operators";
import {throwError} from "rxjs/internal/observable/throwError";
import { ajax } from 'rxjs/ajax';

@Injectable({
  providedIn: 'root'
})
export class AppSourcesService {

  constructor(private http: HttpClient) { }
  appSettings:any={};
  print:string='';
  extra:string='';

  load() {
    return new Promise<boolean>((resolve: (a: boolean) => void): void => {
      this.http.get('/apps/molsa/searchsocialworker/assets/config/app-settings.json',{headers:{skip:"true"}})
      .pipe(
        tap(res => this.appSettings=res),
        concatMap(() => this.http.get('/apps/molsa/searchsocialworker/assets/sources/print.html',{ responseType: 'text'})),
        tap(res => this.print =res.toString()),
        concatMap(() => this.http.get('/apps/molsa/searchsocialworker/assets/sources/extra.html',{ responseType: 'text'} )),
        tap(res => {
          this.extra = res.toString();
          resolve(true);
      }),             
      catchError(
        (error: any):any => {
          console.log(error);
          resolve(true);
          return throwError(error.json().error || 'Server error');
        })
      ).subscribe();
    });
  };
}
